import {defineStore} from "pinia";
import {Ref, ref} from "vue";
import {IErrorPanel, IErrorPanelKey, IPanel, IPanelKey} from "@/features/chat/chat.types";
import {ITableHeader} from "@/types/table";
import {IFilter} from "@/types/main";
import {DateTime} from "luxon";
import {errorService} from "@/features/errors/errors.service";

export const useErrorStore = defineStore("error", () => {
    const headers: ITableHeader[] = [
        {
            name: "id",
            label: "No",
            width: '50px'
        },
        {
            name: "sender_name",
            label: "Sender",
            width: '150px'
        },
        {
            name: "receiver_name",
            label: "Receiver",
            width: '150px'
        },
        {
            name: "shift_name",
            label: "Shift",
        },
        {
            name: "activity_time",
            label: "Date",
        },
        {
            name: "reply_time_seconds",
            label: "Reply time",
        },
        {
            name: "from",
            label: "From",
        },
        {
            name: "text",
            label: "Message",
            width: '600px'
        },
        {
            name: "save",
            label: "Save",
        },
    ];

    const panels = ref<IErrorPanel>({
        allErrors: true,
        replyTime: false,
        unanswered: false,
        deleted: false,
        edited: false,
    });

    const today = new Date()
    const yesterday = new Date()
    yesterday.setDate(today.getDate() - 1)

    const commonFilter = ref<IFilter>({
        q: '',
        date_from: datepickerToUtcDateOnly(new Date(yesterday)),
        date_to: datepickerToUtcDateOnly(new Date(today)),
        time_from: '',
        time_to: '',
        shift_id: 0,
        account: 0,
        outgoing: null,
        fuzzy: true,
        fuzzy_threshold: 0.3,
        page: 1,
        page_size: 50,
        include_photo_base64: true
    })

    function selectPanel(type: IErrorPanelKey) {
        if (panels.value[type]) {
            panels.value[type] = false;

            let isThereTrue: boolean = false;
            for (const key of Object.keys(panels.value) as (keyof IErrorPanel)[]) {
                if (panels.value[key]) {
                    isThereTrue = true;
                }
            }

        } else {
            panels.value[type] = !panels.value[type];
        }

        if (type === "allErrors") {
            for (const key of Object.keys(panels.value) as (keyof IErrorPanel)[]) {
                if (key !== "allErrors") {
                    panels.value[key] = false;
                }
            }
        } else if (
            type === "replyTime" ||
            type === "unanswered" ||
            type === "deleted" ||
            type === "edited" ||
            type === "text" ||
            type === "call" ||
            type === "voice" ||
            type === "photo"
        ) {
            panels.value.allErrors = false;
        }
    }


    async function getErrors(loading: Ref) {
        try {
            loading.value = true
            let newFilter = {...commonFilter.value};
            if (newFilter.q.length == 0) {
                delete newFilter.fuzzy
                delete newFilter.fuzzy_threshold
            }
            const {data} = await errorService.getErrors(newFilter);
            return data
        } finally {
            loading.value = false
        }
    }

    function datepickerToUtcDateOnly(d: Date | null | undefined) {
        if (!d) return ''
        const local = DateTime.fromJSDate(d)
        return DateTime.utc(local.year, local.month, local.day).toFormat('yyyy-MM-dd')
    }

    return {headers, panels, commonFilter, getErrors, selectPanel};
});
